<template>
  <div class="md-layout">
    <div class="moboileWrap" v-if="isMobile.isMobile">
      <div class="resoureWrap">
        <ul>
          <li class="items">
            <div class="card-icon">
              <img src="@/assets/mylearing/top1.png" width="26" height="26" alt="" />
            </div>
            <p>资源数量</p>
            <h3 class="title">
              <animated-number :value="resoureNum" :key="resoureNum"></animated-number>
            </h3>
          </li>
          <li class="items">
            <div class="card-icon">
              <span class="material-icons" style="font-size: 30px; color: #fff"> person</span>
            </div>
            <p>用户总数</p>
            <h3 class="title">
              <animated-number :value="userNum" :key="userNum"></animated-number>
            </h3>
          </li>
          <li class="items">
            <div class="card-icon">
              <img src="@/assets/mylearing/top3.png" width="26" height="26" alt="" />
            </div>
            <p>发布课程</p>
            <h3 class="title">
              <animated-number :value="fBCourse" :key="fBCourse"></animated-number>
            </h3>
          </li>
          <li class="items">
            <div class="card-icon">
              <span class="material-icons" style="font-size: 30px; color: #fff">mode</span>
            </div>
            <p>在建课程</p>
            <h3 class="title">
              <animated-number :value="zJCourse" :key="zJCourse"></animated-number>
            </h3>
          </li>
        </ul>
      </div>
      <div style="width: 100%">
        <v-carousel height="170" @change="update" hide-delimiters>
          <v-carousel-item>
            <div style="width: 100%; height: 170px; background-color: #e83a75">
              <div style="width: 100%; height: 170px" ref="myCharOne" id="myCharOne"></div>
            </div>
          </v-carousel-item>

          <v-carousel-item>
            <div style="width: 100%; height: 170px; background-color: #4ba64f">
              <div style="width: 100%; height: 170px" ref="myCharTwo" id="myCharTwo"></div>
            </div>
          </v-carousel-item>
          <v-carousel-item>
            <div style="width: 100%; height: 170px; background-color: #14bace">
              <div style="width: 100%; height: 170px" ref="myCharTree" id="myCharTree"></div>
            </div>
          </v-carousel-item>
        </v-carousel>
      </div>

      <div class="courseTitle">
        <div class="card-icon" style="padding: 5px">
          <md-icon>language</md-icon>
          <h5 style="display: inline-block; margin-bottom: 0px; vertical-align: middle">
            精品课程
          </h5>
        </div>
      </div>

      <div class="isMobileWrap">
        <div v-for="item in simulationList" :key="item._id" class="moboileWrapClientWrap">
          <v-card
            elevation="3"
            :max-height="isMobile.isMobile ? '105' : '220'"
            :height="isMobile.isMobile ? '105' : '220'"
            class="cardWrap"
            @click="gotoDetail(item)"
          >
            <v-img
              :lazy-src="item.cover"
              :max-height="isMobile.isMobile ? '80px' : '190px'"
              max-width="100%"
              :src="item.cover"
              class="homeCardImg"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <div style="position: absolute; right: 3px; top: 3px; z-index: 11">
              <v-btn icon :color="item.isCollect ? 'red' : 'grey'" @click.stop="clickcollect(item)">
                <span
                  class="material-icons"
                  :style="{ fontSize: isMobile.isMobile ? '20px' : '30px' }"
                  >favorite</span
                >
                <md-tooltip md-direction="top">点击收藏</md-tooltip>
              </v-btn>
            </div>

            <div class="maskingWrap" :style="{ height: isMobile.isMobile ? '80px' : '' }">
              <div class="contentWrap" :style="{ height: isMobile.isMobile ? '80px' : '' }">
                <div style="float: left; padding: 6px">
                  <p :style="{ fontSize: isMobile.isMobile ? '8px' : '' }">
                    版本号:{{ item.version }}
                  </p>
                  <p :style="{ fontSize: isMobile.isMobile ? '8px' : '' }">
                    发行时间:{{ dateFormat(item.updated_at) }}
                  </p>
                  <p :style="{ fontSize: isMobile.isMobile ? '8px' : '' }">
                    发布人:{{ item.creater }}
                  </p>
                </div>
              </div>
              <div class="colorStyle">
                {{ item.project ? item.project.description : '' }}
              </div>

              <!-- <div class="iconWrap">
                <span
                  @click.stop
                  style="
                    height: 16px;
                    width: 16px;
                    background-image: url('/w10.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    image-rendering: -webkit-optimize-contrast;
                  "
                >
                  <md-tooltip md-direction="top">windows版本</md-tooltip>
                </span>

                <span
                  @click.stop
                  style="
                    height: 17px;
                    width: 17px;
                    background-image: url('/vr.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    image-rendering: -webkit-optimize-contrast;
                  "
                >
                  <md-tooltip md-direction="top">VR版本</md-tooltip>
                </span>

                <span
                  @click.stop
                  style="
                    height: 17px;
                    width: 40px;
                    background-image: url(/webGL.png);
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    background-position-y: 0px;
                    image-rendering: -webkit-optimize-contrast;
                  "
                >
                  <md-tooltip md-direction="top">WebGL版本</md-tooltip>
                </span>

                <span
                  @click.stop
                  style="
                    height: 17px;
                    width: 17px;
                    background-image: url('/az.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    image-rendering: -webkit-optimize-contrast;
                  "
                >
                  <md-tooltip md-direction="top">安卓版本</md-tooltip>
                </span>

                <span
                  @click.stop
                  style="
                    height: 17px;
                    width: 40px;
                    background-image: url(/zspace.png);
                    background-repeat: no-repeat;
                    background-size: 101% 100%;
                    background-position-y: 1px;
                    image-rendering: -webkit-optimize-contrast;
                  "
                >
                  <md-tooltip md-direction="top">ZSpace版本</md-tooltip>
                </span>

                <span
                  @click.stop
                  style="
                    height: 13px;
                    width: 40px;
                    background-image: url(/km.png);
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    background-position-y: -1px;
                    image-rendering: -webkit-optimize-contrast;
                  "
                >
                  <md-tooltip md-direction="top">KMAX版本</md-tooltip>
                </span>

                <span
                  @click.stop
                  style="
                    height: 16px;
                    width: 23px;
                    background-image: url('/dr.png');
                    border-left: 1px solid rgb(255, 255, 255);
                    padding-left: 4px;
                    background-repeat: no-repeat;
                    background-position-x: 15px;
                    background-position: 6px 1px;
                    background-size: 65% 89%;
                    image-rendering: -webkit-optimize-contrast;
                  "
                >
                  <md-tooltip md-direction="top">单机模式</md-tooltip>
                </span>
              </div> -->
            </div>
            <div
              :style="{
                background: '#fff',
                width: '100%',
                height: isMobile.isMobile ? '25px' : '15%',
                lineHeight: isMobile.isMobile ? '25px' : '15%',
                position: 'absolute',
                bottom: '0',
                textAlign: 'center',
              }"
            >
              <p
                class="titleName"
                :style="{
                  marginTop: isMobile.isMobile ? '0px' : '6px',
                  fontSize: isMobile.isMobile ? '12px' : '14px',
                }"
              >
                {{ item.name }}
              </p>
            </div>
          </v-card>
        </div>
      </div>
    </div>
    <div
      class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      v-if="!isMobile.isMobile"
    >
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon top1">
            <img src="@/assets/mylearing/top1.png" width="30" height="30" alt="" />
          </div>
          <p class="category">资源数量</p>
          <h3 class="title">
            <animated-number :value="resoureNum" :key="resoureNum"></animated-number>
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            +{{
              this.nextDateResoure > this.preDateResoure
                ? this.nextDateResoure - this.preDateResoure
                : 0
            }}较上周
          </div>
        </template>
      </stats-card>
    </div>

    <div
      class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      v-if="!isMobile.isMobile"
    >
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <span class="material-icons iconHeaderWrap"> person</span>
          </div>
          <p class="category">用户总数</p>
          <h3 class="title">
            <animated-number :value="userNum" :key="userNum"></animated-number>
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            +{{ this.nextUserNum > this.preUserNum ? this.nextUserNum - this.preUserNum : 0 }}较上周
          </div>
        </template>
      </stats-card>
    </div>

    <div
      class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      v-if="!isMobile.isMobile"
    >
      <stats-card header-color="rose">
        <template slot="header">
          <div class="card-icon top1">
            <img src="@/assets/mylearing/top3.png" width="30" height="30" alt="" />
          </div>
          <p class="category">发布课程</p>
          <h3 class="title">
            <animated-number :value="fBCourse" :key="fBCourse"></animated-number>
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            +{{
              this.nextfBCouese > this.prefBCouese ? this.nextfBCouese - this.prefBCouese : 0
            }}较上周
          </div>
        </template>
      </stats-card>
    </div>

    <div
      class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      v-if="!isMobile.isMobile"
    >
      <stats-card header-color="warning">
        <template slot="header">
          <div class="card-icon">
            <span class="material-icons iconHeaderWrap">mode</span>
          </div>
          <p class="category">在建课程</p>
          <h3 class="title">
            <animated-number :value="zJCourse" :key="zJCourse"></animated-number>
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            +{{
              this.nextzJCourse > this.prezJCourse ? this.nextzJCourse - this.prezJCourse : 0
            }}较上周
          </div>
        </template>
      </stats-card>
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33 pieBar"
      v-if="!isMobile.isMobile"
    >
      <div class="chartsWrap">
        <div class="myPieChar myPieCharOne">
          <div style="width: 100%; height: 200px" ref="myCharOne" id="myCharOne"></div>
        </div>
      </div>
      <div class="barDownWrap">
        <div class="conBot">
          <p class="category">资源总数</p>
          <p class="category">最近10天</p>
        </div>
      </div>
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33 pieBar"
      v-if="!isMobile.isMobile"
    >
      <div class="chartsWrap">
        <div class="myPieChar myPieCharTwo">
          <div style="width: 100%; height: 200px" ref="myCharTwo" id="myCharTwo"></div>
        </div>
      </div>
      <div class="barDownWrap">
        <div class="conBot">
          <p class="category">课程学习天数</p>
          <p class="category">最近10天</p>
        </div>
      </div>
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33 pieBar"
      v-if="!isMobile.isMobile"
    >
      <div class="chartsWrap">
        <div class="myPieChar myCharTree">
          <div style="width: 100%; height: 200px" ref="myCharTree" id="myCharTree"></div>
        </div>
      </div>
      <div class="barDownWrap">
        <div class="conBot">
          <p class="category">日活跃用户数</p>
          <p class="category">最近10天</p>
        </div>
      </div>
    </div>

    <div class="md-layout-item md-size-100" v-if="!isMobile.isMobile">
      <global-sales-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>language</md-icon>
          </div>
          <h5 class="title">精品课程</h5>
        </template>
        <template slot="content">
          <div class="md-layout modelWraps">
            <div
              style="overflow: hidden; width: 100%; height: auto"
              class="md-layout"
              v-if="simulationList.length <= 0"
            >
              <v-sheet
                v-for="(index, item) in 8"
                :key="index"
                :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
                class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 modelClientWrap"
              >
                <v-skeleton-loader class="mx-auto" max-width="100%" type="card"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div
              v-else
              v-for="item in simulationList"
              :key="item._id"
              class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 modelClientWrap"
            >
              <v-card
                elevation="6"
                max-height="220"
                height="220"
                class="cardWrap"
                @click="gotoDetail(item)"
              >
                <v-img
                  :lazy-src="item.cover"
                  max-height="190px"
                  max-width="100%"
                  :src="item.cover"
                  class="homeCardImg"
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <div style="position: absolute; right: 3px; top: 3px; z-index: 11">
                  <v-btn
                    icon
                    :color="item.isCollect ? 'red' : 'grey'"
                    @click.stop="clickcollect(item)"
                  >
                    <span class="material-icons" style="font-size: 30px">favorite</span>
                    <md-tooltip md-direction="top">点击收藏</md-tooltip>
                  </v-btn>
                </div>

                <div class="maskingWrap">
                  <div class="contentWrap">
                    <div style="float: left; padding: 6px">
                      <p>版本号:{{ item.version }}</p>
                      <p>发行时间:{{ dateFormat(item.updated_at) }}</p>
                      <p>发布人:{{ item.creater }}</p>
                    </div>
                  </div>
                  <div class="colorStyle">
                    {{ item.project ? item.project.description : '' }}
                  </div>

                  <!-- <div class="iconWrap">
                    <span
                      @click.stop
                      style="
                        height: 16px;
                        width: 16px;
                        background-image: url('/w10.png');
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        image-rendering: -webkit-optimize-contrast;
                      "
                    >
                      <md-tooltip md-direction="top">windows版本</md-tooltip>
                    </span>

                    <span
                      @click.stop
                      style="
                        height: 17px;
                        width: 17px;
                        background-image: url('/vr.png');
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        image-rendering: -webkit-optimize-contrast;
                      "
                    >
                      <md-tooltip md-direction="top">VR版本</md-tooltip>
                    </span>

                    <span
                      @click.stop
                      style="
                        height: 17px;
                        width: 40px;
                        background-image: url(/webGL.png);
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        background-position-y: 0px;
                        image-rendering: -webkit-optimize-contrast;
                      "
                    >
                      <md-tooltip md-direction="top">WebGL版本</md-tooltip>
                    </span>

                    <span
                      @click.stop
                      style="
                        height: 17px;
                        width: 17px;
                        background-image: url('/az.png');
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        image-rendering: -webkit-optimize-contrast;
                      "
                    >
                      <md-tooltip md-direction="top">安卓版本</md-tooltip>
                    </span>

                    <span
                      @click.stop
                      style="
                        height: 17px;
                        width: 40px;
                        background-image: url(/zspace.png);
                        background-repeat: no-repeat;
                        background-size: 101% 100%;
                        background-position-y: 1px;
                        image-rendering: -webkit-optimize-contrast;
                      "
                    >
                      <md-tooltip md-direction="top">ZSpace版本</md-tooltip>
                    </span>

                    <span
                      @click.stop
                      style="
                        height: 13px;
                        width: 40px;
                        background-image: url(/km.png);
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        background-position-y: -1px;
                        image-rendering: -webkit-optimize-contrast;
                      "
                    >
                      <md-tooltip md-direction="top">KMAX版本</md-tooltip>
                    </span>

                    <span
                      @click.stop
                      style="
                        height: 16px;
                        width: 23px;
                        background-image: url('/dr.png');
                        border-left: 1px solid rgb(255, 255, 255);
                        padding-left: 4px;
                        background-repeat: no-repeat;
                        background-position-x: 15px;
                        background-position: 6px 1px;
                        background-size: 65% 89%;
                        image-rendering: -webkit-optimize-contrast;
                      "
                    >
                      <md-tooltip md-direction="top">单机模式</md-tooltip>
                    </span>
                  </div> -->
                </div>
                <div
                  style="
                    background: #fff;
                    width: 100%;
                    height: 15%;
                    line-height: 15%;
                    position: absolute;
                    bottom: 0;
                    text-align: center;
                  "
                                class="titleNameWrap"
                >
                  <p class="titleName">{{ item.name }}</p>
                </div>
              </v-card>
            </div>
          </div>
        </template>
      </global-sales-card>
    </div>

    <div class="md-layout-item md-size-100" v-if="!isMobile.isMobile">
      <Pagination
        :page.sync="paginationModel.page"
        :total="paginationModel.total"
        :items-per-page.sync="paginationModel.itemsPerPage"
        @refresh="findList"
      />
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
// import { ProductCard, Pagination } from "@/components";
import Pagination from '@/components/Pagination/index';
import { listSimulation, setcollect } from '@/api/simulation';
import AsyncWorldMap from '@/components/WorldMap/AsyncWorldMap.vue';
import {
  StatsCard,
  ChartCard,
  ProductCard,
  PricingCard,
  AnimatedNumber,
  GlobalSalesCard,
  GlobalSalesTable,
  modelView,
  // Pagination,
} from '@/components';
import { mapGetters } from 'vuex';
import { listResourceLibraryAll } from '@/api/resource_library';
import moment from 'moment';
export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  components: {
    StatsCard,
    ChartCard,
    AnimatedNumber,
    ProductCard,
    PricingCard,
    GlobalSalesCard,
    GlobalSalesTable,
    modelView,
    AsyncWorldMap,
    Pagination,

    // Pagination
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  data() {
    return {
      chartsData: [
        {
          id: 1,
          parentClass: 'myPieChar myCharTree',
          refClass: 'myCharOne',
          title: '资源总数',
          dayTile: '最近10天',
        },

        {
          id: 2,
          parentClass: 'myPieChar myPieCharTwo',
          refClass: 'myCharTwo',
          title: '课程学习天数',
          dayTile: '最近10天',
        },
        {
          id: 3,
          parentClass: 'myPieChar myCharTree',
          refClass: 'myCharTree',
          title: '日活跃用户数',
          dayTile: '最近10天',
        },
      ],
      resoureNum: 0, //资源数量
      userNum: 0, //用户总数
      fBCourse: 0, //发布课程
      zJCourse: 0, //在建课程

      preDateResoure: 0, //上周添加数量
      nextDateResoure: 0, //本周添加数量
      preUserNum: 0, //上周用户数量
      nextUserNum: 0, //本周用户数量
      prefBCouese: 0, //上周发布课程数量
      nextfBCouese: 0, //本周发布课程数量
      prezJCourse: 0, //上周在建课程
      nextzJCourse: 0, //本周在建课程

      product1: './img/bdz.png',
      product2: './img/plc.png',
      product3: './img/jzjk.png',
      seq2: 0,
      mapData: {
        'CN-50': 120,
        'CN-31': 1300,
        'CN-54': 540,
        'CN-33': 690,
        'CN-62': 200,
        'CN-23': 200,
        'CN-NanHai-2': 600,
        'CN-NanHai-6': 300,
        'CN-44': 2920,
      },
      simulationList: [],
      // 分页

      paginationModel: {
        page: 1,
        itemsPerPage: 8,
        total: 0,
      },
      headers: [
        { text: '名称', align: 'start', value: 'name', sortable: false },
        {
          text: '修改时间',
          align: 'start',
          value: 'updated_at',
          sortable: false,
        },
      ],
      isLoading: false,
      initOneBack: {}, //选中的那一项
      tableData: [],
      option1: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        formatter: function (params) {
            if (params) {
              return params[0].data + '件';
            }
            // return params.data+'天'
            // var date = new Date();
            // var year = date.getFullYear();
            // return year + '-' + params[0].name + '<br/>';
          },
        xAxis: {
          type: 'category',
          data: ['图片', '音频', '视频', '文档', '模型', '其他'],
          axisTick: {
            // 坐标轴刻度
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#fff', // 将X轴线颜色设为红色
            },
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            // 坐标轴在 grid 区域中的分隔线
            lineStyle: {
              type: 'dashed', // 线的类型
              color: '#fff', // 分隔线颜色
            },
          },

          axisLabel: {
            show: true,
            color: '#ffffff',
          },
        },
        series: [
          {
            itemStyle: {
              color: '#fff', //自定义颜色值或者使用预定义的颜色名称
            },
            barWidth: '30%',
            data: [],
            type: 'bar',
            //  center: ['30%', '50%'],
          },
        ],
      },
      option2: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: function (params) {
            if (params) {
              return params[0].data + '天';
            }
            // return params.data+'天'
            // var date = new Date();
            // var year = date.getFullYear();
            // return year + '-' + params[0].name + '<br/>';
          },
        },

        xAxis: {
          type: 'category',
          data: this.returnDay(),

          // axisLabel: {
          //   show: true,
          //   interval: 'auto',
          //   interval: 0,
          //   rotate: 45,
          // },
          axisTick: {
            // 坐标轴刻度
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#fff', // 将X轴线颜色设为红色
            },
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            // 坐标轴在 grid 区域中的分隔线
            lineStyle: {
              type: 'dashed', // 线的类型
              color: '#fff', // 分隔线颜色
            },
          },

          axisLabel: {
            show: true,
            color: '#ffffff',
          },
        },
        series: [
          {
            itemStyle: {
              color: '#fff', //自定义颜色值或者使用预定义的颜色名称
            },
            data: [150, 230, 224, 218, 135, 147, 260, 218, 135, 147],
            type: 'line',
          },
        ],
      },
      option3: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: function (params) {
            if (params) {
              return params[0].data + '人';
            }
            // var date = new Date();
            // var year = date.getFullYear();
            // return year + '-' + params[0].name + '<br/>';
          },
        },

        xAxis: {
          type: 'category',
          data: this.returnDay(),
          axisTick: {
            // 坐标轴刻度
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#fff', // 将X轴线颜色设为红色
            },
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            // 坐标轴在 grid 区域中的分隔线
            lineStyle: {
              type: 'dashed', // 线的类型
              color: '#fff', // 分隔线颜色
            },
          },

          axisLabel: {
            show: true,
            color: '#ffffff',
          },
        },
        series: [
          {
            itemStyle: {
              color: '#fff', //自定义颜色值或者使用预定义的颜色名称
            },
            data: [20, 30, 70, 60, 50, 40, 60, 30, 20, 80],
            type: 'line',
          },
        ],
      },
      chartsNum: 0,
      chartBox1: null,
      chartBox2: null,
      chartBox3: null,
    };
  },
  async created() {
    this.getResoureLIst();
  },
  async mounted() {
    this.findList();
    this.initChartTree();

    if (this.isMobile.isMobile) {
      this.initChart();
    } else {
      this.initChart();
      this.initChartTwo();
      this.initChartTree();
    }
  },
  watch: {
    'isMobile.isMobile'(news) {
      if (!news) {
        setTimeout(() => {
          this.chartBox1.dispose();
          this.chartBox2.dispose();
          this.chartBox3.dispose();
          this.initChart();
          this.initChartTwo();
          this.initChartTree();
        }, 500);
      }
    },
  },
  methods: {
    update(index) {
      if (index == 0) {
        this.disposes();
        let timer = setTimeout(() => {
          this.initChart();
          clearTimeout(timer);
        }, 400);
      }
      if (index == 1) {
        this.disposes();
        let timer = setTimeout(() => {
          this.initChartTwo();
          clearTimeout(timer);
        }, 400);
      }
      if (index == 2) {
        this.disposes();
        let timer = setTimeout(() => {
          this.initChartTree();
          clearTimeout(timer);
        }, 400);
      }
    },
    //移动端销毁echarts实例
    disposes() {
      if (this.chartBox1) {
        this.chartBox1.dispose();
      }

      if (this.chartBox2) {
        this.chartBox2.dispose();
      }
      if (this.chartBox3) {
        this.chartBox3.dispose();
      }
    },
    getResoureLIst() {
      let params = {
        name: '',
      };
      let _this = this;
      listResourceLibraryAll(params).then(res => {
        console.log(res, '================');
        let arr = [
          res.data.image,
          res.data.audio,
          res.data.video,
          res.data.document,
          res.data.model,
          res.data.other,
        ];

        _this.resoureNum = res.data.resoureNum;
        this.userNum = res.data.userNum;
        this.fBCourse = res.data.fBCourse;
        this.zJCourse = res.data.zJCourse;
        (this.preDateResoure = res.data.preDateResoure), //上周添加数量
          (this.nextDateResoure = res.data.nextDateResoure), //本周添加数量
          (this.preUserNum = res.data.preUserNum), //上周用户数量
          (this.nextUserNum = res.data.nextUserNum), //本周用户数量
          (this.prefBCouese = res.data.prefBCouese), //上周发布课程数量
          (this.nextfBCouese = res.data.nextfBCouese), //本周发布课程数量
          (this.prezJCourse = res.data.prezJCourse), //上周在建课程
          (this.nextzJCourse = res.data.nextzJCourse), //本周在建课程
          (this.option1.series[0].data = arr);
        this.initChart();
      });
    },
    returnDay() {
      let arr = [];
      for (var i = 1; i <= 10; i++) {
        let date = this.getRecentDay(i);
        arr.push(date);
      }
      arr = arr.reverse();
      return arr;
    },
    initChart() {
      let myCharOne = document.getElementById('myCharOne');
      if (!myCharOne) {
        return;
      }
      if (this.chartBox1) {
        this.chartBox1.setOption(this.option1);
      }
      this.chartBox1 = echarts.init(document.getElementById('myCharOne'));
      let option = this.option1;

      if (this.isMobile.isMobile) {
        (option.title = [
          {
            text: '资源总数',
            left: '35%',
            top: '10px',
            textStyle: {
              fontSize: 12,
              color: '#fff',
            },
          },
          {
            text: '最近10天',
            left: '50%',
            top: '10px',
            textStyle: {
              fontSize: 12,
              color: '#fff',
            },
          },
        ]),
          (option.grid = {
            // y: 25,  //移动
            right: '3%', // 右边距 //移动
            top: '25%', // 可以设置 top 偏移量
            bottom: '20%',
          });
      } else {
        delete option.title;
        option.grid = {
          y: 25, //移动
          right: '3%', // 右边距 //移动
        };
      }

      this.chartBox1.setOption(option);
      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.chartBox1.resize();
      });
    },

    initChartTwo() {
      let myCharTwo = document.getElementById('myCharTwo');
      if (!myCharTwo) {
        return;
      }
      if (this.chartBox2) {
        this.chartBox2.setOption(this.option2);
      }
      this.chartBox2 = echarts.init(document.getElementById('myCharTwo'));
      let option = this.option2;
      if (this.isMobile.isMobile) {
        (option.title = [
          {
            text: '课程学习天数',
            left: '32%',
            top: '10px',
            textStyle: {
              fontSize: 12,
              color: '#fff',
            },
          },
          {
            text: '最近10天',
            left: '58%',
            top: '10px',
            textStyle: {
              fontSize: 12,
              color: '#fff',
            },
          },
        ]),
          (option.grid = {
            // y: 25,
            right: '3%', // 右边距
            top: '25%', // 可以设置 top 偏移量
            bottom: '20%',
          });
      } else {
        delete option.title;
        option.grid = {
          y: 25, //移动
          right: '3%', // 右边距 //移动
        };
      }
      this.chartBox2.setOption(option);
      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.chartBox2.resize();
      });
    },
    initChartTree() {
      let myCharTree = document.getElementById('myCharTree');
      if (!myCharTree) {
        return;
      }
      if (this.chartBox3) {
        // this.chartBox3 = echarts.init(document.getElementById('myCharTree'));
        let option = this.option3;
        this.chartBox3.setOption(option);
      }
      this.chartBox3 = echarts.init(document.getElementById('myCharTree'));
      let option = this.option3;

      if (this.isMobile.isMobile) {
        option.title = [
          {
            text: '日活跃用户数',
            left: '32%',
            top: '10px',
            textStyle: {
              fontSize: 12,
              color: '#fff',
            },
          },
          {
            text: '最近10天',
            left: '58%',
            top: '10px',
            textStyle: {
              fontSize: 12,
              color: '#fff',
            },
          },
        ];

        option.grid = {
          // y: 25, //移动
          right: '3%', // 右边距 //移动
          top: '25%', // 可以设置 top 偏移量
          bottom: '20%',
        };
      } else {
        delete option.title;
        option.grid = {
          y: 25, //移动
          right: '3%', // 右边距 //移动
        };
      }
      this.chartBox3.setOption(option);
      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.chartBox3.resize();
      });
    },
    getYearDay() {
      var date = new Date();
      var year = date.getFullYear();
      return year;
    },
    getRecentDay: function (n) {
      let day = moment(new Date()).subtract(n, 'days').format('MM-DD');
      // console.log(day);
      return day;
    },
    clickcollect(data) {
      let params = {
        isCollect: data.isCollect == 1 ? 0 : 1,
        date: new Date(),
        _id: data._id,
      };
      if (params.isCollect == 0) {
        params.date.setHours(0); // 将小时部分设置为0
        params.date.setMinutes(0); // 将分钟部分设置为0
        params.date.setSeconds(0); // 将秒部分设置为0
        params.date.setMilliseconds(0); // 将毫秒部分设置为0
      } else if (params.isCollect == 1) {
        params.date = new Date();
      }

      setcollect(params).then(res => {
        if (res.code == '200') {
          this.$notify({
            timeout: 1500,
            message: params.isCollect ? '收藏成功' : '取消收藏',
            icon: 'add_alert',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
          this.findList();
        }
      });
    },
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    //跳转页面
    gotoDetail(item) {
      this.$router.push({
        path: '/SimClassDetails',
        query: {
          _id: item._id,
          type: 'home',
        },
      });

      // var NewUrl = window.location.origin+'/simClassDetails';

      // window.open(NewUrl,'_blank','width=' + screen.width + ', height=' + screen.height + ', top=0, left=0, toolbar=no, menubar=no, location=no, status=no, help=no, center=yes, scrollbars=yes, resizable=yes, minmizebutton=yes, maxmizebutton=yes');
    },

    clickRow(data) {
      this.tableData.forEach(item => {
        if (data._id == item._id) {
          this.$set(item, 'isClickRow', true);
          this.initOneBack = item;
        } else {
          this.$set(item, 'isClickRow', false);
        }
      });
    },
    findList() {
      this.isLoading = true;
      listSimulation({
        status: 1,
        perPage: this.paginationModel.itemsPerPage,
        currentPage: this.paginationModel.page,
        refer: 'all',
        majorGroup: '',
        majorGroup2: '',
        name: '',
      }).then(res => {
        this.simulationList = res.data.rows;
        this.isLoading = false;
        let tableData = [];
        res.data.rows.forEach((item, index) => {
          if (index <= 4) {
            tableData.push(item);
          }
        });
        this.homeTableMethods(tableData);
        this.paginationModel.total = res.data.total;
      });
      this.isLoading = true;
    },
    //前端实现首页表格时间转换以及排序并添加默认选中第一条
    homeTableMethods(data) {
      this.tableData = [];
      data.filter(item => (item.updated_at = this.renderTime(item.updated_at)));
      data.forEach((item, index) => {
        item.isClickRow = false;
        if (index == 0) {
          item.isClickRow = true;
          this.initOneBack = item;
        }
      });
      this.tableData = data;
    },
    //时间转换
    renderTime(date) {
      var dateee = new Date(date).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000).toLocaleDateString().replace(/\//g, '-');
    },
    async openClientDetail(platform = 'PC', item) {
      // if (!['VR', 'PC'].includes(platform)) return;
      const params = encodeURIComponent(
        JSON.stringify({
          token: localStorage.getItem('token'),
          course: item.courseId ?? item.project.course,
          projectId: item.project ? item.project._id : '',
          version: item.version,
          platform,
          simulationId: item._id,
          runtime: process.env.VUE_APP_RUNTIME,
        })
      );
      location.href = `MetaSpaceProject://${params}`;
    },

    // async openClient(item) {
    //   const params = encodeURIComponent(
    //     JSON.stringify({
    //       projectId: item.project._id,
    //       version: item.version,
    //       platform: item.platform ?? 'PC',
    //       // , runtime: 'meta_trial'
    //       runtime: 'meta_dev',
    //     })
    //   );
    //   location.href = `MetaSpaceProject://${params}`;
    // },
  },
};
</script>

<style>
.versionCont {
  text-align: center;
  width: 200px;
  line-height: 30px;
  background: rgb(76 175 80);
  position: absolute;
  box-shadow: 0px 0px 8px 0px #fff;
  border: 1px dashed white;
  font-weight: bold;
  color: #fff;
  left: -50px;
  transform: rotate(324deg);
  top: 25px;
}

@media (max-width: 599px) {
  table tbody tr > td {
    width: 100% !important;
  }
}
</style>
<style scoped>
.cardWrap {
  margin: 10px 0px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.cardWrap:hover .maskingWrap {
  opacity: 1;
}

.maskingWrap {
  text-indent: 2px;
  opacity: 0;
  position: absolute;
  transition: 0.5s;
  width: 100%;
  height: 85%;
  /* padding: 10px; */
  background-color: #000000a3;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.colorStyle {
  color: #fff;
}

.titleName {
  color: #000;
  font-size: 14px;
  margin-top: 6px;
  padding: 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0px;
  line-height: 25px;
}

.titleName a {
  font-size: 14px;
}

.stats {
  color: #000;
}

.openClient {
  position: absolute;
  right: 0;
  top: 0;
  margin: auto;
  bottom: 0px;
  width: 32px;
  border-radius: 5px;
  height: 32px;
  z-index: 888;
  cursor: pointer;
  background-image: url('../../assets/img/openClient.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.modelWraps {
  min-height: 440px;
}

.openClient:hover {
  transform: scale(1.1);
}

.img {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}

@media (max-width: 599px) {
  .pagination {
    /* width: 100% !important; */
    margin-bottom: 10px !important;
  }
}
.recentUpdates {
  /* border-bottom: 1px solid gray !important; */
  /* min-height: 300px; */
  margin-bottom: 10px;
  padding-left: 10px !important;
}

.img-card {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0;
}

.md-tab {
  max-width: 600px;
  max-height: 400px;
  overflow: auto;
}
.card-padding {
  padding: 0px;
  margin: 0px !important;
}
.v-card__actions {
  padding: 0px !important;
}
.isClickRow {
  background-color: #eee;
}
.imgHovers {
  border-radius: 4px;
  height: 250px;
  overflow: hidden;
  border: none;
}

.trainingRoomStepByStep:hover .imgHovers {
  transition: 0.4s ease-in-out;
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14),
    0 5px 22px 4px rgba(0, 0, 0, 0.12) !important;
  border: none;
}
.trainingRoomStepByStep {
  position: relative;
  padding: 0 0 !important;
}

.loadingEl {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 999;
}

.homeCardImg {
  height: 100%;
}
/deep/ .homeCardImg .v-image__image {
  background-size: 100% 100%;
  height: 100%;
}

.contentWrap {
  width: 100%;
  overflow: hidden;
  color: #fff;
  font-size: 13px;
}
.contentWrap p {
  margin-bottom: 5px;
}
.iconWrap {
  width: 98%;
  line-height: auto;
  height: auto;
  position: absolute;
  bottom: 0;
  right: 5px;
  text-align: right;
}
.iconWrap span {
  margin: 0 5px;
  display: inline-block;
}

.colorStyle {
  color: #fff;
}
>>> .md-card-content {
  padding: 15px 10px !important;
}
.homeRightImg {
  height: 250px;
  width: 100%;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
  border: none;
}

.iconHeaderWrap {
  font-size: 36px;
  line-height: 56px;
  width: 56px;
  height: 56px;
  text-align: center;
  color: #fff;
}

.pieBar {
  position: relative;
  height: 300px;
}
.barDownWrap {
  height: 235px;
  width: 95%;
  position: absolute;
  bottom: 35px;
  left: 0;
  right: 0;
  margin: auto;
  /* background: red; */
  background: #fff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);

  border-radius: 6px;
}

.myPieChar {
  height: 160px;
  width: 90%;
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 6px;
  animation-duration: 1s;
  animation-fill-mode: both;
  -webkit-transition: all 0.3s cubic-bezier(0.34, 1.61, 0.7, 1);
  transition: all 0.3s cubic-bezier(0.34, 1.61, 0.7, 1);
  overflow: hidden;
  z-index: 9;
  /* cubic-bezier(0.2,-3,0.8,2) */
}

.chartsWrap {
  height: 180px;
  overflow: hidden;
  width: 100%;
}
.myPieChar:hover {
  transform: translateY(-40px);
}
.myPieCharOne {
  background: #e83a75;
  box-shadow: 0 12px 20px -10px rgba(233, 30, 99, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12),
    0 7px 8px -5px rgba(233, 30, 99, 0.2);
}
.myPieCharTwo {
  background: #4ba64f;
  box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12),
    0 7px 8px -5px rgba(76, 175, 80, 0.2);
}
.myCharTree {
  background: #14bace;
  box-shadow: 0 12px 20px -10px rgba(0, 188, 212, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12),
    0 7px 8px -5px rgba(0, 188, 212, 0.2);
}

.top1 {
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
}
.top1 img {
  width: 30px;
  height: 30px;
  vertical-align: inherit;
}

.conBot {
  margin-bottom: 0px;
  position: absolute;
  bottom: 0px;
  left: 20px;
}

/* 响应式样式 */

.moboileWrap {
  padding: 0 15px;
  height: auto;
  overflow: hidden;
  width: 100%;
}
.resoureWrap {
  width: 100%;
  height: auto;
  overflow: hidden;
  margin: 0px 0 10px;
}
.resoureWrap ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.resoureWrap ul li {
  text-align: center;
  padding: 0 10px;
  overflow: hidden;
  border-radius: 4px;
}

.resoureWrap ul li p {
  margin: 0px;
  font-size: 12px;
  color: #fff;
}
.resoureWrap ul li h3 {
  margin: 0;
  padding: 0px;
}
.resoureWrap ul li .title {
  color: #fff;
  height: 28px;
  line-height: 28px;
}
.resoureWrap ul li:nth-child(1) img {
}
.resoureWrap ul li img {
  margin-top: 5px;
}
.resoureWrap ul li .card-icon {
  height: 30px;
}

.resoureWrap ul li:nth-child(1) {
  background: linear-gradient(60deg, #66bb6a, #43a047);
  box-shadow: 0 3px 5px -2px rgba(76, 175, 80, 0.28), 0 4px 10px 0px rgba(0, 0, 0, 0.12),
    0 3px 4px -5px rgba(76, 175, 80, 0.2);
}
.resoureWrap ul li:nth-child(2) {
  background: linear-gradient(60deg, #26c6da, #00acc1);
  box-shadow: 0 3px 5px -2px rgba(0, 188, 212, 0.28), 0 4px 10px 0px rgba(0, 0, 0, 0.12),
    0 3px 4px -5px rgba(0, 188, 212, 0.2);
}
.resoureWrap ul li:nth-child(3) {
  background: linear-gradient(60deg, #ec407a, #d81b60);
  box-shadow: 0 3px 5px -2px rgba(233, 30, 99, 0.28), 0 4px 10px 0px rgba(0, 0, 0, 0.12),
    0 3px 4px -5px rgba(233, 30, 99, 0.2);
}
.resoureWrap ul li:nth-child(4) {
  background: linear-gradient(60deg, #ffa726, #fb8c00);
  box-shadow: 0 3px 5px -2px rgba(255, 152, 0, 0.28), 0 4px 10px 0px rgba(0, 0, 0, 0.12),
    0 3px 4px -5px rgba(255, 152, 0, 0.2);
}

.moboileWrapClientWrap {
  padding-right: 0;
  padding-left: 0px;
}
/* 响应式样式 */

@media (max-width:1160px) {
.courseWrap{
  height: 160px !important;
}

.modelClientWrap{
  height: 160px !important;
}
.cardWrap {
  height: 160px !important;
}

.homeCardImg {
  height: 130px !important;
}
.maskingWrap {
  height: 130px !important;
}
.titleNameWrap{
  height: 25px !important;
  line-height: 25px !important;
}
.titleNameWrap p{
  height: 25px !important;
  line-height: 25px !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}
/* .titleNameWrap .intoCourse{
  height: 25px !important;
  line-height: 25px !important;
}

.titleNameWrap .intoCourse span{
  height: 25px !important;
  line-height: 25px !important;
} */



/* .isMobileWrap{}

.courseList{} */
 
}

@media (max-width:850px) {
.courseWrap{

  height: 130px !important;
}

.courseList{
  height: 130px !important;
}
.cardWrap{
  height: 130px !important;
}
.editWrap{
  height: 100px !important;
}
.coureListImg {
  height: 100px !important;
}
.coureNameWrap{
  height: 20px !important;
  line-height: 20px !important;
}
.coureNameWrap p{
  height: 20px !important;
  line-height: 20px !important;

}
.coureNameWrap .intoCourse{
  height: 20px !important;
  line-height: 20px !important;
  width: 40% !important;
}

.coureNameWrap .intoCourse span{
  height: 20px !important;
  line-height: 20px !important;
}

 
}

@media (max-width:750px) {
.courseWrap{

  height: 100px !important;
}

.courseList{
  height: 100px !important;
}
.cardWrap{
  height: 100px !important;
}

.coureListImg {
  height: 80px !important;
}

.coureNameWrap{
  height: 20px !important; 
  line-height: 20px !important;
  margin-top: 0px;
}
.editWrap{
  height: 110px !important;
}
.coureNameWrap p{
  height: 20px !important;
  line-height: 20px !important;
  font-size: 12px;
  margin-bottom: 0px;
}
.coureNameWrap .intoCourse{
  height: 20px !important;
  line-height: 20px !important;
}

.coureNameWrap .intoCourse span{
  height: 20px !important;
  line-height: 20px !important;
  font-size: 12px;
}

 
}


@media (max-width: 600px) {
  .courseTitle {
    margin-top: 15px;
    background: #fff;
  }
  .isMobileWrap {
    background-color: #fff;
  }
  .isMobileWrap {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
  }
  .moboileWrapClientWrap {
    width: 140px;
    height: 110px;
    margin: 10px 0;
  }
  .isMobileWrap .moboileWrapClientWrap:nth-child(1) {
    margin-top: 0px !important;
  }
  .isMobileWrap .moboileWrapClientWrap:nth-child(2) {
    margin-top: 0px !important;
  }

  .resoureWrap {
    margin-bottom: 15px;
  }
}

</style>
